export enum ETipoOperacao {
  Entrada = 0,
  Saida = 1,
}
